import unsubscribeStyle from './Unsubscribe.module.css'
import {Box, CircularProgress, TextField} from "@mui/material";
import {CustomButton, CustomCheckbox, CustomFormControlLabel, CustomTextField} from "../assets/mui-styles/styles";
import {useEffect, useState} from "react";

import logo from '../assets/images/pianob.gif'
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {API_URL} from "../config";


const OverlayCircularProgress = ({ loading }) => {

    return (
        <div className={unsubscribeStyle.overlay}>
            <CircularProgress style={{color:'#E31E13'}}></CircularProgress>
        </div>
    );
};

export const Unsubscribe = () => {
    const { id } = useParams();
    const [userData, setUserData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const [success, setSuccess] = useState(false);


    const navigate = useNavigate();

    const [errors, setErrors] = useState({});

    useEffect(() => {
        // Effettua la chiamata GET per ottenere i dati dell'utente
        axios.get(`${API_URL}/user/${id}`)
            .then(response => {
                setUserData(response.data);
                // Precompile form with data from id
                setLoading(false);
            })
            .catch(error => {
                console.info(error)
                setError(true)
                setLoading(false);
            });
    }, [id]);

    const handleRedirect = () => {
        navigate(`/${id}`);
    };

    const confirmUnsubscribe = async () => {
        setLoading(true);
        try {
            await axios.post(`${API_URL}/unsubscribe/${id}`);
        } catch (err) {
            console.error(err);
        } finally {
            setSuccess(true);
            setLoading(false);
        }
    };


    if(error) return (
        <div className={unsubscribeStyle.mainContainer}>
            C'è stato un errore
        </div>
    )


    return(
        <div className={unsubscribeStyle.mainContainer}>
            {loading &&
                <OverlayCircularProgress></OverlayCircularProgress>
            }
            <div className={unsubscribeStyle.infoContainer}>
                <img src={logo} alt={'logo'} className={unsubscribeStyle.logo}/>
                {!loading && !success &&  <>
                    <div className={unsubscribeStyle.textContainer}>
                        <p style={{fontSize: '25px'}}>
                            {`Ciao${userData.nome ? ' ' + userData.nome : ''},`}<br/>
                            Sei sicuro che non vuoi più essere invitato agli eventi di Piano B ?
                        </p>
                        <Box sx={{
                            display:'flex',
                            gap:5,
                            alignItems:'center'
                        }}>
                            <CustomButton
                                sx={{marginTop: '1rem', fontSize:{md:'1.5rem', xs:'1rem'}, px:2}}
                                onClick={() => handleRedirect()}
                            >
                                Invitami ancora
                            </CustomButton>
                            <CustomButton
                                sx={{marginTop: '1rem', fontSize:{md:'1.5rem', xs:'1rem'}}}
                                onClick={() => confirmUnsubscribe()}
                            >
                                Si
                            </CustomButton>
                        </Box>

                    </div>
                </>}

                {!loading && success &&  <>
                    <div className={unsubscribeStyle.textContainer}>
                        <p style={{fontSize: '25px'}}>
                            Non riceverai più i nostri inviti.
                        </p>

                    </div>
                </>}

            </div>
            {!loading &&
                <div className={unsubscribeStyle.imgContainer1}>

                </div>
            }
        </div>
    )
}